<div class="flex items-center justify-between px-4 py-3 border-b-2 border-primary">
  <span class="text-xs font-bold uppercase tracking-wide text-slate-800">
    Notificaciones
  </span>
</div>

<div class="max-h-80 overflow-y-scroll custom-scrollbar">
  @for (item of notificaciones; track $index) {
    <c-item-notification
      (click)="onClick(item)"
      [cuerpo]="item.cuerpo"
      [titulo]="item.titulo"
      [fecha]="item.fecha_carga"
      [abierto]="item.abierto"
    />
  } @empty {
    <p class="text-center opacity-55 italic py-6">
      No hay notificaciones para mostrar
    </p>
  }
</div>

@if (count > 5) {
  <a
    routerLink="notificaciones"
    class="flex items-center justify-center w-full border-t border-slate-200 bg-slate-50 py-2 text-xs font-bold uppercase tracking-wide text-slate-500 hover:bg-primary-light hover:text-primary transition-colors"
  >
    Ver todas
  </a>
}
